import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "getInitials",
})
export class GetInitialsPipe implements PipeTransform {
  transform(name: string): string {
    if (!name) {
      return "N/A";
    }
    const nombres = name.split(" ");
    if (nombres.length > 1) {
      const inicial = nombres[1].charAt(0);
      return (nombres[0].charAt(0) + inicial).toUpperCase();
    }
    if (nombres.length === 1) {
      return (nombres[0].charAt(0) + nombres[0].charAt(1)).toUpperCase();
    }
    return "N/A";
  }
}
